module.exports = __webpack_public_path__ + "static/media/comment.ea33277c.svg";